module.exports = __webpack_public_path__ + "img/development-manage.fc0048d1.svg";